import { memo } from 'react';
import Box from '@mui/material/Box';
// Local files
import ErrorWrapper from 'components/Common/ErrorWrapper/ErrorWrapper';
import SuperbillFlow from 'components/Flows/SuperbillFlows/SuperbillFlows';
import SuperbillAnalysisDrawer from 'components/Analyses/SuperbillAnalyses/Drawer/Drawer';
import SuperbillGoalDrawer from 'components/Flows/SuperbillGoals/Drawer/Drawer';

const SuperbillFlows = () => {

  return (
    <Box sx={{ flexGrow: 1, display: 'flex', overflow: 'hidden'  }}>
      <SuperbillAnalysisDrawer />
      <SuperbillGoalDrawer />
      <SuperbillFlow />
    </Box>
  );
};

const WrappedComponent = props => {
  return (
    <ErrorWrapper>
      <SuperbillFlows {...props} />
    </ErrorWrapper>
  );
};

export default memo(WrappedComponent);